<template>
  <div class="wrapper">
    <navigator></navigator>

    <sidebar></sidebar>

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <!-- HEADER -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <section class="content">
        <div class="container-fluid">
          <!-- Small boxes (Stat box) -->

          <!-- Main row -->
          <div class="row">
            <!-- Início conteúdo -->
            <section class="connectedSortable col-md-8">
              <!-- Solicitar Conteúdo -->
              <div class="card">
                <div class="overlay" v-if="loading">
                  <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>

                <div class="card-header">
                  <h3 class="card-title">Solicitar Conteúdo</h3>

                  <div class="card-tools">
                    <router-link to="/" title="Voltar" class="btn btn-tool" data-card-widget>
                      <i class="fas fa-backspace"></i>
                    </router-link>
                  </div>
                </div>
                <!-- /.card-header -->
                <!-- form start -->

                <div class="card-body">
                  <form role="form">
                    <!-- CLIENTE -->
                    <div class="form-group" v-if="loginObj.client == null">
                      <label for="cliente">Cliente</label>
                      <v-select
                        id="cliente"
                        placeholder="Selecione o cliente"
                        label="nome_fantasia"
                        :options="clientes"
                        :reduce="clientes => clientes.id"
                        v-model="conteudo.client_id"
                        @input="selClientes"
                      ></v-select>
                    </div>

                    <!-- TITULO -->
                    <div class="form-group">
                      <label for="titulo">Título</label>
                      <input
                        id="titulo"
                        autocomplete="off"
                        type="text"
                        class="form-control"
                        v-model="conteudo.titulo"
                      />
                    </div>

                    <!-- PAUTA -->
                    <div class="form-group">
                      <label for="pauta">Pauta</label>
                      <textarea id="pauta" class="form-control" v-model="conteudo.pauta"></textarea>
                    </div>

                    <!-- Soliticação Extra -->
                    <div v-if="loginObj.client == null" class="form-group">
                      <div class="input-group">
                        <label for="solicitacao_extra" class="mr-2">É Solicitação Extra?</label>
                        <input type="checkbox"  style="height: 1.6rem;" name="solicitacao_extra" id="solicitacao_extra" v-model="conteudo.solicitacao_extra">
                      </div>
                      <transition name="slide-down">
                        <div v-if="conteudo.solicitacao_extra">
                          <label for="solicitacao_horas" class="mr-2">Quantidade de horas</label>
                          <div>
                            <input class="form-control" style="width: 5rem !important; display:inline-block;" type="number" min="0" name="solicitacao_horas" id="solicitacao_horas" v-model="solicitacao_horas">
                            <span v-if="saldo_calculado !== null && !isNaN(saldo_calculado)" class="ml-2" :class="{ 'text-danger' : saldo_calculado < 0 }">Saldo de horas: {{ saldo_calculado }}</span>
                          </div>
                        </div>
                      </transition>
                    </div>

                    <!-- CICLO -->
                    <div class="form-group" v-if="loginObj.client == null">
                      <label for="data_entrega">Ciclo do conteúdo</label>

                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="far fa-calendar-alt"></i>
                          </span>
                        </div>

                        <!-- <input
                          id="datahora_publicacao"
                          type="datetime-local"
                          step="1"
                          v-model="data_hora_publicacao"
                        />-->
                        <!-- //@change="convDataEntrega" -->
                        <input
                          id="ciclo"
                          autocomplete="off"
                          type="date"
                          class="form-control"
                          v-model="conteudo.ciclo"
                        />
                      </div>
                    </div>

                    <!-- PRAZO -->
                    <div class="form-group" v-if="loginObj.client == null">
                      <label for="data_entrega">Data de entrega</label>

                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="far fa-calendar-alt"></i>
                          </span>
                        </div>

                        <!-- <input
                          id="datahora_publicacao"
                          type="datetime-local"
                          step="1"
                          v-model="data_hora_publicacao"
                        />-->
                        <!-- //@change="convDataEntrega" -->
                        <input
                          id="data_entrega"
                          autocomplete="off"
                          type="date"
                          class="form-control"
                          v-model="data_entrega"
                          @change="convDataEntrega"
                        />
                      </div>
                    </div>

                    <!-- <div class="form-group">
                      <label for="data_entrega">Data de entrega</label>
                      <input
                        v-mask="'##/##/####'"
                        id="data_entrega"
                        autocomplete="off"
                        type="text"
                        class="form-control"
                        @change="convDataEntrega"
                        v-model="data_entrega"
                      />
                    </div>-->

                    <!-- TIPO -->
                    <div class="form-group" v-if="loginObj.client == null">
                      <label for="tipo">Tipo</label>
                      <v-select
                        taggable
                        id="tipo"
                        @change="convDataEntrega"
                        placeholder="Selecione o tipo"
                        label="descricao"
                        :options="tipos"
                        :reduce="tipos => tipos.id"
                        v-model="conteudo.conteudo_tipo_id"
                        @input="selClientes"
                      ></v-select>
                    </div>

                    <!-- MODERADOR -->
                    <div class="form-group" v-if="loginObj.client == null">
                      <label for="moderador">Moderador</label>
                      <v-select
                        taggable
                        id="moderador"
                        placeholder="Selecione o Moderador"
                        label="name"
                        :options="usuarios"
                        :reduce="usuarios => usuarios.id"
                        :selectable="user => user.deleted_at == null"
                        v-model="conteudo.moderador_id"
                        @input="travarConteudo"
                      ></v-select>
                    </div>

                    <!-- ATENDENTE -->
                    <div class="form-group" v-if="loginObj.client == null">
                      <label for="atendente">Sucesso do Cliente</label>
                      <v-select
                        taggable
                        id="atendente"
                        placeholder="Selecione o Atendente"
                        label="name"
                        :options="usuarios"
                        :reduce="usuarios => usuarios.id"
                        :selectable="user => user.deleted_at == null"
                        v-model="conteudo.atendente_id"
                        @input="travarConteudo"
                      ></v-select>
                    </div>

                    <!-- FUNCAO EXECUTOR -->
                          <template v-if="loginObj.client == null && conteudo.executores_funcoes">
                            <label>Executores</label>
                            <div class="row" :key="executor.id" v-for="(executor, idx) in conteudo.executores_funcoes">
                              <div class="col">
                                <!-- PRIMEIRA FUNCAO -->
                                <div class="form-group">
                                  <label for="atendente">Função {{ idx+1 }}</label>
                                  <v-select
                                    taggable
                                    id="funcao1"
                                    placeholder="Selecione a função"
                                    v-model="executor.funcao_id"
                                    label="name"
                                    :options="funcoes"
                                    :reduce="funcoes => funcoes.id"
                                    v-bind:value="funcoes.id"
                                    v-bind:key="funcoes.id"
                                  ></v-select>
                                </div>
                              </div>
                              <div class="col">
                                <!-- PRIMEIRA FUNCAO -->
                                <div class="form-group">
                                  <label for="executor1">Executor</label>
                                  <v-select
                                    taggable
                                    id="executor1"
                                    placeholder="Selecione o executor"
                                    label="name"
                                    :options="usuarios"
                                    :reduce="usuarios => usuarios.id"
                                    v-model="executor.executor_id"
                                  ></v-select>
                                </div>
                              </div>
                              <div class="col">
                                <!-- PRIMEIRA FUNCAO -->
                                <div class="form-group">
                                  <label for="prazo1">Prazo</label>
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">
                                        <i class="far fa-calendar-alt"></i>
                                      </span>
                                    </div>

                                    <input
                                      id="prazo1"
                                      autocomplete="off"
                                      type="date"
                                      class="form-control"
                                      v-model="executor.prazo"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-1" v-if="loginObj.isAdmin">
                                <div class="form-group">
                                  <label for="executor1"></label>
                                  <button
                                    type="button"
                                    class="btn btn-block btn-outline-secondary color-secondary btn-xs m-2"
                                    v-on:click.stop="removerExecutor(idx)"
                                  >
                                    <i class="nav-icon fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="row" v-if="loginObj.isAdmin">
                              <button type="button" @click="adicionarExecutor" class="btn btn-secondary btn-lg btn-block">Adicionar executor</button>
                            </div>
                          </template>
                  </form>
                </div>
                <!-- /.card-body -->

                <div class="card-footer">
                  <button
                    type="submit"
                    v-on:click="postConteudo()"
                    class="btn btn-primary"
                  >Solicitar conteúdo</button>
                </div>
              </div>
            </section>

            <!-- Final conteúdo -->

            <section class="connectedSortable col-md-4" v-if="$debugWindow">
              <div class="card">
                <div class="card-header">
                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                      <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <pre>NOVA SOLICITACAO: {{conteudo}}</pre>
                </div>
              </div>
            </section>
          </div>
          <!-- /.row (main row) -->
        </div>
        <!-- /.container-fluid -->
      </section>
      <!-- /.content -->
    </div>

    <!-- /.content-wrapper -->
    <footer-comp></footer-comp>
  </div>
  <!-- ./wrapper -->
</template>

<style scoped>
  /* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-down-enter-active {
  transition: all .2s ease;
}
.slide-down-leave-active {
  transition: all .2s ease;
}
.slide-down-enter, .slide-down-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>

<script>
import axios from "axios";

axios.defaults.withCredentials = true;

import $ from "jquery";

import "jquery-ui";

import "jquery-ui-bundle";

import "summernote/dist/summernote-lite.css";

import "summernote/dist/summernote-lite.min.js";

import "summernote/dist/lang/summernote-pt-BR.js";

//import moment from 'moment-timezone'

//import $ from "jquery";

export default {
  name: "conteudo-solicitar",
  data() {
    return {
      conteudo: {
        executores_funcoes: [],
      },
      conteudo_url: this.$apiUrl + "/conteudos",
      estados_url: this.$apiUrl + "/conteudo_estado",
      tipos_url: this.$apiUrl + "/conteudo_tipo",
      clientes_url: this.$apiUrl + "/clients",
      usuarios_url: this.$apiUrl + "/users",
      funcoes_url: this.$apiUrl + "/funcoes",
      login: {},
      loginObj: {},
      estados: [],
      tipos: [],
      clientes: [],
      usuarios: [],
      funcoes: [],
      projetos: [],
      data_entrega: null,
      dataEntrega: null,
      loading: false,
      saldo_horas: null,
      solicitacao_horas: 1,
      modificado: false,
    };
  },
  methods: {
    selClientes() {
      //console.log(event.target.value);

      if(this.conteudo.client_id == null) {
        if(!this.modificado) {
          this.$set(this.conteudo, 'executor1_id', null);
          this.$set(this.conteudo, 'executor2_id', null);
          this.$set(this.conteudo, 'executor3_id', null);
          this.$set(this.conteudo, 'funcao_executor1_id', null);
          this.$set(this.conteudo, 'funcao_executor2_id', null);
          this.$set(this.conteudo, 'funcao_executor3_id', null);

          this.$set(this.conteudo, 'moderador_id', null);
          this.$set(this.conteudo, 'atendente_id', null);
        }

        return;
      }

      let args = new URLSearchParams({ client_id: this.conteudo.client_id}).toString();

      if(this.modificado) return;

      axios
      .get(this.conteudo_url + '/ultimo_preenchimento?' + args)
      .then(response => {
        this.$set(this.conteudo, 'executores_funcoes', response.data.message.executores_funcoes);

        this.$set(this.conteudo, 'moderador_id', response.data.message.moderador_id);
        this.$set(this.conteudo, 'atendente_id', response.data.message.atendente_id);

        this.$nextTick(function() {
          this.modificado = false;
        })
      })
      .catch(error => {
        console.error(error);
      });
    },
    getEstados() {
      axios
        .get(this.estados_url, this.login)
        .then(response => {
          this.estados = response.data;
        })
        .catch(error => {
         console.error("Estados: " + error);
        });
    },
    getTipos() {
      axios
        .get(this.tipos_url, this.login)
        .then(response => {
          this.tipos = response.data;
        })
        .catch(error => {
         console.error("Tipos: " + error);
        });
    },
    getClientes() {
      axios
        .get(this.clientes_url, this.login)
        .then(response => {
          this.clientes = response.data;
        })
        .catch(error => {
         console.error("Clientes: " + error);
        });
    },
    getUsuarios() {
      axios
        .get(this.usuarios_url + '?with_deleted=1', this.login)
        .then(response => {
          this.usuarios = response.data;
        })
        .catch(error => {
         console.error("Usuarios: " + error);
        });
    },
    getFuncoes() {
      this.loading = true;
      axios
        .get(this.funcoes_url, this.login)
        .then(response => {
          this.funcoes = response.data.message;
          this.loading = false;
        })
        .catch(error => {
         console.error("Funcoes: " + error);
        });
    },
    postConteudo() {
      this.loading = true;

      this.convDataEntrega();

      this.conteudo.pauta = $("#pauta").summernote("code");

      this.conteudo.solicitacao_horas = this.solicitacao_horas;

      if(!this.conteudo.solicitacao_extra) delete this.conteudo.solicitacao_horas;

      if (this.conteudo.executor1_id === undefined) {
        this.conteudo.executor1_id = null;
      }

      if (this.conteudo.executor2_id === undefined) {
        this.conteudo.executor2_id = null;
      }

      if (this.conteudo.executor3_id === undefined) {
        this.conteudo.executor3_id = null;
      }


      axios
        .post(this.conteudo_url, this.conteudo, this.login)
        .then(response => {
          var _t = this;

          _t.retorno = response.data;

          this.loading = false;

          //ALERT - INICIO
          if (_t.retorno.status == 201) {
            _t.$router.push("/");
            window.onbeforeunload = null;
            _t.showalert("Sucesso", _t.retorno.message, "success");
          } else {
            if (typeof _t.retorno.message === "string") {
              _t.showalert("Atenção", _t.retorno.message, "warning");
            } else {
              const msg = Object.entries(_t.retorno.message); //CONVERTE OBJETO EM ARRAY COM OS VALORES 'entries'

              for (var i = 0; i < msg.length; i++) {
                var msgerro = msg[i][1];
                _t.showalert("Atenção", msgerro, "warning");
              }
            }
          }
          //ALERT - FINAL
        });
    },
    convDataEntrega() {
      this.dataEntrega = this.data_entrega;
    },
    travarConteudo() {
      this.modificado = true;
    },
    adicionarExecutor() {
      this.conteudo.executores_funcoes.push({
        funcao_id: null,
        executor_id: null,
        prazo: null,
      });
    },
    removerExecutor(idx) {
      this.conteudo.executores_funcoes.splice(idx, 1);
    },
  },
  computed: {
    saldo_calculado: function () {
      return this.saldo_horas - this.solicitacao_horas;
    },
  },
  watch: {
    'conteudo.client_id': function (client_id) {
      axios
      .get(this.clientes_url + '/' + client_id + '/solicitacoes')
      .then( response => {
        this.saldo_horas = parseInt(response.data.message);
      })
      .catch(error => {
        // console.log(error); //Removed for production build
        console.error(error);
      });
    },
    dataEntrega(newDate) {
      //localStorage.login = newLogin;
      //var prazo = this.$moment(newDate).format('X');
      var prazo = this.$moment(newDate).format("YYYY-MM-DD");
      this.conteudo.prazo = prazo;
    }
  },
  mounted() {
    $(document).ready(function() {
      //Texto inicial
      $('#pauta').html('<p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;" id="docs-internal-guid-e8093d77-7fff-b489-d730-a24fd8ce4aff"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Prezad@ cliente! Para podermos ser mais eficazes na sua entrega, por gentileza detalhe ao máximo sua demanda:</span></p><br><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Objetivo da solicitação</span></p><ul style="margin-top:0;margin-bottom:0;padding-inline-start:48px;"><li dir="ltr" style="list-style-type: disc; font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre;" aria-level="1"><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;" role="presentation"><font color="#424242"><span style="font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">Explicar de forma clara qual é o propósito da solicitação.&nbsp;</span></font></p></li></ul><br><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">A quem queremos impactar?</span></p><ul style="margin-top:0;margin-bottom:0;padding-inline-start:48px;"><li dir="ltr" style="list-style-type: disc; font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre;" aria-level="1"><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;" role="presentation"><font color="#424242"><span style="font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">Especificar a segmentação de público que deseja atingir. Caso não haja, escreva “público em geral”.</span></font></p></li></ul><br><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Prazo&nbsp;</span></p><ul style="margin-top:0;margin-bottom:0;padding-inline-start:48px;"><li dir="ltr" style="list-style-type: disc; font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre;" aria-level="1"><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;" role="presentation"><font color="#424242"><span style="font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">Qual é o prazo para essa demanda. Lembrando que uma atividade criada nesta semana entrará na pauta da produção da semana seguinte.</span></font></p></li></ul><br><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Formato necessário (especificações técnicas do formato)</span></p><ul style="margin-top:0;margin-bottom:0;padding-inline-start:48px;"><li dir="ltr" style="list-style-type: disc; font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre;" aria-level="1"><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;" role="presentation"><font color="#424242"><span style="font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">Ex.: WhatsApp 1500x1500 .gif,&nbsp; apresentação comercial A4 .pdf, email html5, imagem em PNG ou JPEG, anúncio/artigo para revista (limite de palavras/caracteres), etc.</span></font></p></li></ul><br><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Links de recursos para criação da solicitação</span></p><ul style="margin-top:0;margin-bottom:0;padding-inline-start:48px;"><li dir="ltr" style="list-style-type: disc; font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre;" aria-level="1"><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;" role="presentation"><font color="#424242"><span style="font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">Insira aqui todos os links úteis que você possui para a criação da solicitação: imagens das pessoas envolvidas, logos de terceiros, etc. Nos envie por email para que não perca a resolução.</span></font></p></li></ul><br><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Sugestões, ideias ou referências:</span></p><ul style="margin-top:0;margin-bottom:0;padding-inline-start:48px;"><li dir="ltr" style="list-style-type: disc; font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre;" aria-level="1"><p dir="ltr" style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;" role="presentation"><font color="#424242"><span style="font-size: 11pt; font-family: Arial; background-color: transparent; font-weight: 400; font-style: normal; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">Descreva aqui ou insira links com sugestões de referência e exemplos para a criação da solicitação.</span></font></p></li></ul>');
      $("#pauta").summernote({
        lang: "pt-BR",
        placeholder: "Pauta ...",
        tabsize: 2,
        height: 500,
        toolbar: [
          ["style", ["style"]],
          ["font", ["bold", "underline", "clear"]],
          ["fontname", ["fontname"]],
          ["color", ["color"]],
          ["para", ["ul", "ol", "paragraph"]],
          ["table", ["table"]],
          ["insert", ["link", "picture", "video"]],
          ["view", ["fullscreen", "codeview", "help"]]
        ]
      });
    });

    if (localStorage.getItem("login")) {
      try {
        const loginJSON = JSON.parse(localStorage.getItem("login"));

        this.loginObj = loginJSON;

        this.login = {
          headers: {
            Authorization: "Bearer ".concat(loginJSON.api_token),
            Accept: "application/json",
            "Cache-Control": "no-cache"
          }
        };

        if ( this.loginObj.isAdmin === 1 ) {
          this.loginObj.client = null
        }

        this.getEstados();
        this.getTipos();
        this.getClientes();
        this.getUsuarios();
        this.getFuncoes();

        //this.conteudo.executor1_id = null;
        ///this.conteudo.executor2_id = null;
        //this.conteudo.executor3_id = null;

        this.conteudo.conteudo_estado_id = 2; //EM PRODUCAO
      } catch (e) {
        this.$router.push("/login");
        localStorage.removeItem("login");
      }
    } else {
      this.$router.push("/login");
    }
  },
  destroyed() {}
};
</script>
